import { Injectable } from '@angular/core';
import { convert as cronConvert } from 'crontzconvert';
import { DateTime } from 'luxon';

@Injectable({
	providedIn: 'root',
})
export class CronService {
	constructor() {}

	getTimeZoneNameFromOffset(offset: number) {
		// Lista de fusos horários possíveis
		const timeZones = DateTime.now().zoneName ? (<any>Intl).supportedValuesOf('timeZone') : [];

		// Encontrar o fuso horário correspondente ao offset
		for (const zone of timeZones) {
			const dt = DateTime.now().setZone(zone);
			if (dt.offset === offset * 60) {
				return zone;
			}
		}
		return 'Time zone not found';
	}

	convertCronExpression(cronExp: string, fromTimezone: string, toTimezone: string) {
		//cronConvert uses 6 digits cron, the last one meaning the year, when it converts the expression it adds one digit to the expression
		//we are removing it since we are using 5 digits cron.
		let convertedCron = cronConvert(cronExp, fromTimezone, toTimezone);
		convertedCron = convertedCron.split(' ');
		convertedCron.shift();
		convertedCron = convertedCron.join(' ');
		return convertedCron;
	}
}
